import type { CSSProperties } from "react";
import { brandLoaderSrc } from "@humansignal/core";
import styles from "./spinner.module.css";
import { cn } from "@humansignal/shad/utils";

export type SpinnerProps = {
  className?: string;
  style?: CSSProperties;
  size?: number;
  stopped?: boolean;
};

export const Spinner = ({ className, style, size = 32 }: SpinnerProps) => {
  const fullClassName = cn(styles.spinner, className);

  const sizeWithUnit = typeof size === "number" ? `${size}px` : size;

  return (
    <div className={fullClassName} style={{ ...(style ?? {}), "--spinner-size": sizeWithUnit }}>
      <img className={styles.mark} src={brandLoaderSrc()} alt="" aria-hidden="true" />
    </div>
  );
};
